'use client';

import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import CopyrightNotice from './copyright-notice';
import Disclaimer from './disclaimer';
import DisclaimerTrigger from './disclaimer-trigger';
import FooterBottomLineLinks from './footer-bottom-line-links';

interface SimpleFooterProps {
  className?: string;
  tag?: keyof JSX.IntrinsicElements;
}

export default function SimpleFooter({ className, tag: Tag = 'footer' }: SimpleFooterProps) {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  function handleClickDisclaimer() {
    setShowDisclaimer(!showDisclaimer);
    setTimeout(() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }), 0);
  }

  return (
    <Tag
      className={twMerge(
        'flex flex-col-reverse md:flex-col md:justify-center first-letter:bg-light-alt text-dark mt-auto py-6 text-center text-xs px-4 dark:bg-[#153154] dark:text-white dark:text-sm',
        className
      )}
    >
      <CopyrightNotice />
      <nav
        aria-label="Footer links"
        className="flex flex-wrap justify-center leading-3 my-1 space-x-2"
      >
        <DisclaimerTrigger onClick={handleClickDisclaimer} />
        <FooterBottomLineLinks />
      </nav>
      {showDisclaimer && <Disclaimer />}
    </Tag>
  );
}
